import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AppClientRow {
  id: string;
  username: string;
  name: string | null;
  lastName: string | null;
  email: string | null;
  person_code: string | null;
  app_version: string | null;
  uses_new_app: boolean;
  app_version_updated_at: string | null;
  is_online: boolean;
  status: boolean;
  created_at: string | null;
}

export interface AppClientsResponse {
  rows: AppClientRow[];
  total: number;
  page: number;
  limit: number;
  stats: {
    total_with_app: number;
    with_version: number;
    uses_new_app: number;
  };
}

export interface AppClientsQuery {
  page?: number;
  limit?: number;
  search?: string;
  channel?: 'all' | 'new';
  sort?: 'recent' | 'name';
}

/**
 * Consume el endpoint read-only del core `GET /api/admin/app-clients`.
 * Fuente 100% core (kredit-api-MT); NO toca el BFF ni `app_users`.
 */
@Injectable({ providedIn: 'root' })
export class AppClientsService {
  private url_la = environment.BASE_LA;

  constructor(private http: HttpClient) {}

  getAppClients = async (query: AppClientsQuery = {}): Promise<AppClientsResponse | undefined> => {
    const params: any = {};
    if (query.page) params.page = String(query.page);
    if (query.limit) params.limit = String(query.limit);
    if (query.search && query.search.trim()) params.search = query.search.trim();
    if (query.channel) params.channel = query.channel;
    if (query.sort) params.sort = query.sort;

    try {
      const res = await lastValueFrom(
        this.http.get<any>(`${this.url_la}/api/admin/app-clients`, {
          headers: { 'content-type': 'application/json' },
          params,
        })
      );
      return res?.resp as AppClientsResponse;
    } catch (error) {
      console.error('Error en getAppClients:', error);
      return undefined;
    }
  };
}
